<div *ngIf="useFigureIcon">
    <section class="country-section" *ngIf="type === 0">
      <figure *ngIf="countryCode?.trim()" class="figure-country">
        <img loading="lazy" [flag]="countryCode"
          alt="" class="img-country"/>
      </figure>
      <div class="section-country-text text-size-base">
        <section>
          <span *ngIf="portName?.trim(); else emptyOrigin" class="font-semibold">
            {{ portName }}
          </span>
          <ng-template #emptyOrigin>
            <span class="text-sub-color font-italic">{{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}</span>
          </ng-template>
          <br>
          {{ countryName != '-' ? countryName : ''  }}
        </section>
      </div>
    </section>
    <section class="country-section" *ngIf="type === 1">
      <figure *ngIf="countryCode?.trim()" class="figure-country">
        <img loading="lazy" [flag]="countryCode"
          alt="" class="img-country"/>
      </figure>
      <div class="section-country-text text-size-base">
        <section>
          <span *ngIf="airportName?.trim(); else emptyOrigin" class="font-semibold">
            {{ airportName }}
          </span>
          <ng-template #emptyOrigin>
            <span class="text-sub-color font-italic">{{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}</span>
          </ng-template>
          <br>
          {{ countryName != '-' ? countryName : ''  }}
        </section>
      </div>
    </section>
      <section class="country-section" *ngIf="type === 2">
      <figure *ngIf="countryCode?.trim()" class="figure-country">
        <img loading="lazy" [flag]="countryCode"
          alt="" class="img-country"/>
      </figure>
      <div class="section-country-text text-size-base">
        <section>
          <span *ngIf="cityName?.trim(); else emptyOrigin" class="font-semibold">
            {{ cityName }}
          </span>
          <ng-template #emptyOrigin>
            <span class="text-sub-color font-italic">{{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}</span>
          </ng-template>
          <br>
          {{ countryName != '-' ? countryName : ''  }}
        </section>
      </div>
    </section>
</div>
<div *ngIf="!useFigureIcon">
  <div style="margin-left: 10px;" class="flex justify-content-start align-items-center container-flex-full"
    *ngIf="type === 0">
    <img [flag]="countryCode" height="50px" alt=""/>
    <div class="flex flex-column" style="margin-left: 10px;">
      <span style="font-weight: bolder; font-size: small;">{{countryName}}</span>
      <span style="font-size: small;" *ngIf="showLocationName">
        {{portName}}
      </span>
    </div>
  </div>

  <div style="margin-left: 10px;" class="flex justify-content-start align-items-center container-flex-full" *ngIf="type === 1">
    <img [flag]="countryCode" height="50px" alt=""/>
    <div class="flex flex-column" style="margin-left: 10px;">
      <span style="font-weight: bolder; font-size: small;">{{countryName}}</span>
      <span style="font-size: small;" *ngIf="showLocationName">
        {{airportName}}
      </span>
    </div>
  </div>

  <div style="margin-left: 10px;" class="flex justify-content-start align-items-center container-flex-full" *ngIf="type === 2">
    <img [flag]="countryCode" height="50px" alt=""/>
    <div class="flex flex-column" style="margin-left: 10px;">
      <span style="font-weight: bolder; font-size: small;">{{countryName}}</span>
      <span style="font-size: small;" *ngIf="showLocationName">
        {{cityName}}
      </span>
    </div>
  </div>
</div>

